/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NbSidebarModule,
  NbMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbWindowModule,
  NbToastrModule,
  NbAutocompleteModule,
  NbSpinnerService,
} from '@nebular/theme';
import { environment } from './environments/environment';
import { MainService } from './app/public/services/main.service';
import { AuthService } from './app/public/services/auth.service';
import { AuthGuard } from './app/public/guards/auth.guard';
import { LoggedInGuard } from './app/public/guards/logged-in.guard';
import { AlertService } from './app/public/services/alert.service';
import { NavigationService } from './app/public/services/navigation.service';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from './app/@core/core.module';
import { ThemeModule } from './app/@theme/theme.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      NbSidebarModule.forRoot(),
      NbMenuModule.forRoot(),
      NbDatepickerModule.forRoot(),
      NbDialogModule.forRoot(),
      NbWindowModule.forRoot(),
      NbToastrModule.forRoot(),
      CoreModule.forRoot(),
      ThemeModule.forRoot(),
      NbAutocompleteModule
    ),
    MainService,
    AuthService,
    AuthGuard,
    LoggedInGuard,
    AlertService,
    NavigationService,
    NbSpinnerService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
